export class TrackerStatechartMarker {
    symbol: string;
    enabled: boolean;
    fillColor: string;
    radius: number;
}
